import { ProductStoreOrderStatus } from "../api/fetchProductStoreOrders/types";

export const ORDER_STATUS_STYLES: Record<
  ProductStoreOrderStatus,
  { label: string; backgroundColor: string }
> = {
  paid: { label: "Paid", backgroundColor: "#2563EB" },
  shipped: { label: "Shipped", backgroundColor: "#D97706" },
  completed: { label: "Completed", backgroundColor: "#16A34A" },
};

export const ORDER_STATUS_VALUES: ProductStoreOrderStatus[] = [
  "paid",
  "shipped",
  "completed",
];
